export default "__VITE_ASSET__B64NC1bD__"